// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

export const DELETE_SPACE = "mondoo.captain.Captain.DeleteSpace";
